"use client";

import React, { ReactNode } from "react";
import { useClerkAuth } from "@/hooks/use-clerk-auth";
import { useInactivityLogout } from "@/hooks/use-inactivity-logout";
import { useSyncSystemTimezone } from "@/hooks/use-sync-system-timezone";

interface Props {
  children: ReactNode;
}

function ClerkAuthProvider({ children }: Props) {
  useClerkAuth();
  useSyncSystemTimezone();
  useInactivityLogout();

  return <>{children}</>;
}

export default ClerkAuthProvider;

